module.exports = __webpack_public_path__ + "img/c.3686662b.jpg";